import {UIComponent} from "@webfruits/core";
import {SVGComponent} from "@webfruits/toolbox/dist/components/svg/SVGComponent";
import {CoreAssets} from "../../../core/CoreAssets";
import {Signal} from "@webfruits/core/dist/signal/Signal";
import {gsap} from "gsap";

/******************************************************************
 * IconButton
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export type IconButtonType = "close";

export class IconButton extends UIComponent {

    /******************************************************************
     * Properties
     *****************************************************************/

    private _svgIcon: SVGComponent;

    public onClickSignal = new Signal();

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor(private _type: IconButtonType) {
        super(_type + "-button");
        this.initIcon();
        this.initListeners();
    }

    /******************************************************************
     * Public Methodes
     *****************************************************************/

    public show() {
        this.interactive = true;
        gsap.to(this.view, {
            duration: 0.5,
            scale: 1,
            alpha: 1,
            ease: "power4.out"
        })
    }

    public hide(instantly: boolean = false) {
        this.interactive = false;
        gsap.to(this.view, {
            duration: instantly ? 0 : 0.5,
            scale: 0.7,
            alpha: 0,
            ease: "power4.out"
        })
    }

    public updateStyles() {
        this.applyStyle({
            cursor: "pointer"
        })
        this._svgIcon.width = 30;
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    private initIcon() {
        let svgSource: string = "";
        switch (this._type) {
            case "close":
                svgSource = CoreAssets.CLOSE_ICON
        }
        if (!svgSource) {
            console.log("WARNUNG: No icon found");
            return;
        }
        this._svgIcon = new SVGComponent(svgSource);
        this._svgIcon.clearSizeDefinition();
        this.addChild(this._svgIcon);
    }

    private initListeners() {
        this.addNativeListener("mouseenter", () => this.onPointerOver());
        this.addNativeListener("mouseleave", () => this.onPointerOut());
        this.addNativeListener("click", (e: MouseEvent) => this.onPointerClicked(e));
    }

    private playEnterAnimation() {
        gsap.to(this._svgIcon.view, {
            duration: 0.4,
            rotation: 90,
            ease: "power4.out"
        })
    }

    private playLeaveAnimation() {
        gsap.to(this._svgIcon.view, {
            duration: 0.4,
            rotation: 0,
            ease: "power4.out"
        })
    }

    /******************************************************************
     * Events
     *****************************************************************/

    private onPointerOver() {
        this.playEnterAnimation();
    }

    private onPointerOut() {
        this.playLeaveAnimation();
    }

    private onPointerClicked(e: MouseEvent) {
        e.preventDefault();
        e.stopPropagation();
        this.onClickSignal.dispatch();
    }

}
